(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 640px)').matches;
  }

  function initDots(root) {
    if (root.dataset.dotsInit === 'true') return;
    var grid = root.querySelector('[data-scat-grid]');
    var dotsWrap = root.querySelector('[data-scat-dots]');
    if (!grid || !dotsWrap) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.scat-card'));
    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.scat-dot'));
    if (!cards.length || !dots.length) return;

    root.dataset.dotsInit = 'true';

    dots.forEach(function (dot, i) {
      dot.setAttribute('tabindex', '0');
      dot.addEventListener('click', function () {
        if (!isMobile()) return;
        cards[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = cards.indexOf(entry.target);
          if (idx === -1) return;
          dots.forEach(function (d) { d.classList.remove('is-active'); });
          dots[idx].classList.add('is-active');
        });
      },
      { root: grid, threshold: 0.6 }
    );

    cards.forEach(function (card) { observer.observe(card); });
  }

  function initAll() {
    document.querySelectorAll('.scat').forEach(initDots);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-reviews"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSliders() {
    document.querySelectorAll('.sreviews').forEach(function(section) {
      if (section.dataset.sliderInit === 'true') return;
      section.dataset.sliderInit = 'true';

      var track = section.querySelector('[data-review-track]');
      var btnNext = section.querySelector('[data-review-next]');
      var btnPrev = section.querySelector('[data-review-prev]');

      if (!track || !btnNext || !btnPrev) return;

      var scrollAmount = function() {
        var card = track.querySelector('.sreviews-card');
        var gap = parseInt(window.getComputedStyle(track).gap) || 0;
        return card.offsetWidth + gap;
      };

      btnNext.addEventListener('click', function() {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });

      btnPrev.addEventListener('click', function() {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliders);
  } else {
    initSliders();
  }

  document.addEventListener('shopify:section:load', initSliders);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function stripInjectedLinks(root) {
    root.querySelectorAll('.sfaq-q').forEach(function (q) {
      if (q.querySelector('a, span[style], font')) {
        q.textContent = q.textContent;
      }
    });
  }

  function initFaq(root) {
    if (root.dataset.faqInit === 'true') return;
    root.dataset.faqInit = 'true';

    stripInjectedLinks(root);

    root.querySelectorAll('[data-faq]').forEach(function (item) {
      var trigger = item.querySelector('.sfaq-trigger');
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });

    var checks = 0;
    var interval = setInterval(function () {
      stripInjectedLinks(root);
      checks++;
      if (checks > 10) clearInterval(interval);
    }, 500);
  }

  function initAll() {
    document.querySelectorAll('.sfaq').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq2"] && !Shopify.designMode) return;
  try {
    
(function () {
  function stripInjectedLinks(root) {
    root.querySelectorAll('.sfaq-q').forEach(function (q) {
      if (q.querySelector('a, span[style], font')) {
        q.textContent = q.textContent;
      }
    });
  }

  function initFaq(root) {
    if (root.dataset.faqInit === 'true') return;
    root.dataset.faqInit = 'true';

    stripInjectedLinks(root);

    root.querySelectorAll('[data-faq]').forEach(function (item) {
      var trigger = item.querySelector('.sfaq-trigger');
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });

    var checks = 0;
    var interval = setInterval(function () {
      stripInjectedLinks(root);
      checks++;
      if (checks > 10) clearInterval(interval);
    }, 500);
  }

  function initAll() {
    document.querySelectorAll('.sfaq').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 640px)').matches;
  }

  function initFooter(root) {
    if (root.dataset.footInit === 'true') return;
    root.dataset.footInit = 'true';

    root.querySelectorAll('[data-footcol]').forEach(function (col) {
      var trigger = col.querySelector('.sfoot-col-trigger');
      trigger.addEventListener('click', function () {
        if (!isMobile()) return;
        var isOpen = col.classList.contains('is-open');
        col.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.sfoot').forEach(initFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var WISHLIST_KEY = 'shopify_wishlist';

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function initHeader(hdr) {
    var sectionId = hdr.id.replace('SiteHeader-', '');
    var burger = document.getElementById('sn-burger-' + sectionId);
    var overlay = document.getElementById('MobileOverlay-' + sectionId);
    var searchBtn = qs(hdr, '.sn-search-btn');
    var searchDrawer = document.getElementById(searchBtn.getAttribute('aria-controls'));
    var cartBtn = qs(hdr, '.sn-cart-btn');
    var cartDrawer = document.getElementById(cartBtn.getAttribute('aria-controls'));
    var spacer = document.getElementById('HeaderSpacer-' + sectionId);

    /* Scroll: solidify + blur */
    function onScroll() {
      hdr.classList.toggle('scrolled', window.scrollY > 50);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* Measure header height */
    function measureHeight() {
      if (spacer) spacer.style.height = hdr.offsetHeight + 'px';
      document.documentElement.style.setProperty('--sn-measured-height', hdr.offsetHeight + 'px');
    }
    measureHeight();
    window.addEventListener('resize', measureHeight);

    /* Mobile overlay open/close */
    function openOverlay() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      burger.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeOverlay() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      burger.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (burger) {
      burger.addEventListener('click', function () {
        burger.classList.contains('is-open') ? closeOverlay() : openOverlay();
      });
    }
    if (overlay) {
      qsa(overlay, '[data-overlay-close]').forEach(function (btn) { btn.addEventListener('click', closeOverlay); });
      qsa(overlay, '.sn-overlay__nav a').forEach(function (a) { a.addEventListener('click', closeOverlay); });
      var overlayCartBtn = qs(overlay, '[data-overlay-cart-open]');
      if (overlayCartBtn) {
        overlayCartBtn.addEventListener('click', function () {
          closeOverlay();
          openDrawer(cartDrawer, cartBtn);
          refreshCart(hdr, cartDrawer);
        });
      }
      qsa(overlay, '[data-overlay-toggle]').forEach(function (toggle) {
        var submenu = toggle.closest('li').querySelector('[data-overlay-submenu]');
        if (!submenu) return;
        toggle.addEventListener('click', function () {
          var isOpen = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          submenu.style.maxHeight = isOpen ? '0px' : submenu.scrollHeight + 'px';
        });
      });
    }

    /* Drawers */
    function openDrawer(drawer, toggleBtn) {
      drawer.setAttribute('aria-hidden', 'false');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer(drawer, toggleBtn) {
      drawer.setAttribute('aria-hidden', 'true');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (searchBtn && searchDrawer) {
      searchBtn.addEventListener('click', function () {
        openDrawer(searchDrawer, searchBtn);
        var input = qs(searchDrawer, '[data-search-input]');
        if (input) setTimeout(function () { input.focus(); }, 100);
      });
    }
    if (cartBtn && cartDrawer) {
      cartBtn.addEventListener('click', function () {
        openDrawer(cartDrawer, cartBtn);
        refreshCart(hdr, cartDrawer);
      });
    }

    qsa(document, '.sn-drawer').forEach(function (drawer) {
      qsa(drawer, '[data-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var toggle = document.querySelector('[aria-controls="' + drawer.id + '"]');
          closeDrawer(drawer, toggle);
        });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeOverlay();
      qsa(document, '.sn-drawer[aria-hidden="false"]').forEach(function (drawer) {
        var toggle = document.querySelector('[aria-controls="' + drawer.id + '"]');
        closeDrawer(drawer, toggle);
      });
    });

    /* Predictive Search */
    if (searchDrawer) {
      var RECENT_KEY = 'sheinme_recent_searches';
      var input = qs(searchDrawer, '[data-search-input]');
      var results = qs(searchDrawer, '[data-search-results]');
      var suggestions = qs(searchDrawer, '[data-search-suggestions]');
      var spinner = qs(searchDrawer, '[data-search-spinner]');
      var recentBlock = qs(searchDrawer, '[data-search-recent-block]');
      var recentChips = qs(searchDrawer, '[data-search-recent-chips]');
      var clearRecentBtn = qs(searchDrawer, '[data-search-clear-recent]');
      var searchTimer;

      function getRecent() {
        try { return JSON.parse(localStorage.getItem(RECENT_KEY)) || []; } catch (e) { return []; }
      }
      function saveRecent(term) {
        var list = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
        list.unshift(term);
        list = list.slice(0, 5);
        try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
        renderRecent();
      }
      function renderRecent() {
        var list = getRecent();
        if (!recentBlock || !recentChips) return;
        recentBlock.hidden = list.length === 0;
        recentChips.innerHTML = list.map(function (term) {
          return '<button type="button" class="sn-search__recent-chip" data-search-chip>' + term + '</button>';
        }).join('');
        bindChips();
      }
      function bindChips() {
        qsa(searchDrawer, '[data-search-chip]').forEach(function (chip) {
          chip.addEventListener('click', function () {
            input.value = chip.textContent;
            input.focus();
            toggleView();
            runSearch(chip.textContent.trim());
          });
        });
      }
      function toggleView() {
        var hasValue = input.value.trim().length > 0;
        if (suggestions) suggestions.classList.toggle('is-hidden', hasValue);
        if (!hasValue) results.innerHTML = '';
      }

      renderRecent();
      bindChips();
      toggleView();

      if (clearRecentBtn) {
        clearRecentBtn.addEventListener('click', function () {
          try { localStorage.removeItem(RECENT_KEY); } catch (e) {}
          renderRecent();
        });
      }

      input.addEventListener('input', function () {
        clearTimeout(searchTimer);
        var query = input.value.trim();
        toggleView();
        if (query.length < 2) {
          if (spinner) spinner.classList.remove('is-active');
          return;
        }
        if (spinner) spinner.classList.add('is-active');
        searchTimer = setTimeout(function () { runSearch(query); }, 300);
      });

      searchDrawer.querySelector('form').addEventListener('submit', function () {
        var query = input.value.trim();
        if (query.length > 1) saveRecent(query);
      });

      var runSearch = function (query) {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (spinner) spinner.classList.remove('is-active');
            var resource = (data.resources && data.resources.results) || {};
            var products = resource.products || [];
            if (!products.length) {
              results.innerHTML = '<p class="sn-search__empty">No products found for "' + query + '".</p>';
              return;
            }
            var count = resource.products_count || products.length;
            results.innerHTML = products.map(function (p) {
              var img = p.featured_image ? p.featured_image.url : '';
              return '<a href="' + p.url + '" class="sn-search-result">' +
                (img ? '<img src="' + img + '" alt="' + (p.title || '') + '">' : '') +
                '<span class="sn-search-result__info">' +
                  '<span class="sn-search-result__title">' + p.title + '</span>' +
                  '<span class="sn-search-result__price">' + p.price + '</span>' +
                '</span>' +
              '</a>';
            }).join('') + '<a href="/search?q=' + encodeURIComponent(query) + '&type=product" class="sn-search__viewall">' +
              'View all ' + count + ' results ' +
              '<svg viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg>' +
            '</a>';
          })
          .catch(function () {
            if (spinner) spinner.classList.remove('is-active');
            results.innerHTML = '<p class="sn-search__empty">Search is unavailable right now.</p>';
          });
      }
    }

    updateWishlistCount(hdr);
    window.addEventListener('storage', function (e) {
      if (e.key === WISHLIST_KEY) updateWishlistCount(hdr, true);
    });

    hdr._cartDrawer = cartDrawer;
    hdr._cartBtn = cartBtn;
  }

  function formatMoney(cents) { return 'R' + (cents / 100).toFixed(2); }

  function refreshCart(hdr, cartDrawer) {
    if (!cartDrawer) return;
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(hdr, cartDrawer, cart); })
      .catch(function () {});
  }

  function renderCart(hdr, cartDrawer, cart) {
    var itemsEl = qs(cartDrawer, '[data-cart-items]');
    var subtotalEl = qs(cartDrawer, '[data-cart-subtotal]');
    var emptyEl = qs(cartDrawer, '[data-cart-empty]');
    var badges = document.querySelectorAll('[data-cart-count]');

    badges.forEach(function (badge) {
      badge.textContent = cart.item_count;
      badge.classList.toggle('on', cart.item_count > 0);
    });

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    if (!cart.items.length) {
      if (emptyEl) emptyEl.style.display = 'block';
      qsa(itemsEl, '.sn-cart-item').forEach(function (el) { el.remove(); });
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';

    itemsEl.innerHTML = cart.items.map(function (item, index) {
      var img = item.image || '';
      return '<div class="sn-cart-item" data-line="' + (index + 1) + '">' +
        (img ? '<img src="' + img + '" alt="' + item.product_title + '">' : '') +
        '<div class="sn-cart-item__info">' +
          '<a href="' + item.url + '" class="sn-cart-item__title">' + item.product_title + '</a>' +
          (item.variant_title ? '<span class="sn-cart-item__variant">' + item.variant_title + '</span>' : '') +
          '<div class="sn-cart-item__row">' +
            '<div class="sn-cart-item__qty">' +
              '<button type="button" data-qty-decrease>-</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty-increase>+</button>' +
            '</div>' +
            '<span class="sn-cart-item__price">' + formatMoney(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="sn-cart-item__remove" data-remove>Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');

    qsa(itemsEl, '.sn-cart-item').forEach(function (row) {
      var line = parseInt(row.dataset.line, 10);
      var qtySpan = qs(row, '.sn-cart-item__qty span');
      qs(row, '[data-qty-increase]').addEventListener('click', function () {
        changeLine(line, parseInt(qtySpan.textContent, 10) + 1, hdr, cartDrawer);
      });
      qs(row, '[data-qty-decrease]').addEventListener('click', function () {
        changeLine(line, parseInt(qtySpan.textContent, 10) - 1, hdr, cartDrawer);
      });
      qs(row, '[data-remove]').addEventListener('click', function () {
        changeLine(line, 0, hdr, cartDrawer);
      });
    });
  }

  function changeLine(line, quantity, hdr, cartDrawer) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderCart(hdr, cartDrawer, cart); })
      .catch(function () {});
  }

  function updateWishlistCount(hdr, animate) {
    var wishlistBtn = qs(hdr, '.sn-wishlist-btn');
    if (!wishlistBtn) return;
    var badge = qs(wishlistBtn, '[data-wishlist-count]');
    var stored = [];
    try { stored = JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) {}
    var previousCount = parseInt(badge.textContent, 10) || 0;
    badge.textContent = stored.length;
    badge.classList.toggle('on', stored.length > 0);
    wishlistBtn.classList.toggle('has-items', stored.length > 0);
    if (animate && stored.length !== previousCount) {
      wishlistBtn.classList.add('is-pulsing');
      setTimeout(function () { wishlistBtn.classList.remove('is-pulsing'); }, 450);
    }
  }

  function initAnnouncementBar(hdr) {
    var items = qsa(hdr, '.sn-announce__item');
    if (items.length <= 1) return;
    var current = 0;
    setInterval(function () {
      items[current].classList.remove('is-active');
      current = (current + 1) % items.length;
      items[current].classList.add('is-active');
    }, 4000);
  }

  function initAll() {
    qsa(document, '.snhdr').forEach(function (hdr) {
      initHeader(hdr);
      initAnnouncementBar(hdr);
      refreshCart(hdr, hdr._cartDrawer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('cart:refresh', function () {
    qsa(document, '.snhdr').forEach(function (hdr) {
      if (!hdr._cartDrawer) return;
      hdr._cartDrawer.setAttribute('aria-hidden', 'false');
      hdr._cartBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      refreshCart(hdr, hdr._cartDrawer);
    });
  });

  document.addEventListener('wishlist:updated', function () {
    qsa(document, '.snhdr').forEach(function (hdr) { updateWishlistCount(hdr, true); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHeroSwiper(root) {
    if (root.dataset.swiperInitialized === 'true') return;
    var swiperEl = root.querySelector('.hero-swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    var slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
    var autoplayEnabled = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;

    new Swiper(swiperEl, {
      loop: slideCount > 1,
      autoHeight: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 700,
      autoplay: (autoplayEnabled && slideCount > 1) ? { delay: speed, disableOnInteraction: false } : false,
      pagination: slideCount > 1 ? { el: swiperEl.querySelector('.hero-pagination'), clickable: true } : false,
      navigation: slideCount > 1 ? {
        nextEl: swiperEl.querySelector('.hero-button-next'),
        prevEl: swiperEl.querySelector('.hero-button-prev')
      } : false,
      a11y: { enabled: true }
    });

    root.dataset.swiperInitialized = 'true';
  }

  function initAll() {
    var roots = document.querySelectorAll('.hero-slider-section');
    if (!roots.length) return;

    if (typeof Swiper !== 'undefined') {
      roots.forEach(initHeroSwiper);
      return;
    }

    if (!document.getElementById('hero-swiper-css')) {
      var link = document.createElement('link');
      link.id = 'hero-swiper-css';
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      document.head.appendChild(link);
    }

    if (!document.getElementById('hero-swiper-js')) {
      var script = document.createElement('script');
      script.id = 'hero-swiper-js';
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      script.onload = function () { roots.forEach(initHeroSwiper); };
      document.body.appendChild(script);
    } else {
      document.getElementById('hero-swiper-js').addEventListener('load', function () {
        roots.forEach(initHeroSwiper);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-arrivals"] && !Shopify.designMode) return;
  try {
    
(function () {
  var WISHLIST_KEY = 'shopify_wishlist';

  function initSection(root) {
    var toastEl = root.querySelector('[data-la-toast]');
    var loadMoreBtn = root.querySelector('[data-la-loadmore]');
    var loadMoreWrap = root.querySelector('[data-la-loadmore-wrap]');
    var toastTimer;

    function wlGet() {
      try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
    }
    function wlSave(arr) {
      try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr)); } catch (e) {}
    }
    function toast(html) {
      if (!toastEl) return;
      toastEl.innerHTML = html;
      toastEl.classList.add('la-show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('la-show'); }, 2600);
    }
    function syncHearts() {
      var stored = wlGet();
      root.querySelectorAll('.la-heart').forEach(function (btn) {
        var handle = btn.dataset.handle;
        btn.classList.toggle('la-wl', stored.indexOf(handle) !== -1);
      });
    }

    /* Wishlist toggling */
    root.querySelectorAll('.la-heart').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = btn.dataset.handle;
        if (!handle) return;
        var stored = wlGet();
        var idx = stored.indexOf(handle);
        var added = false;
        if (idx !== -1) { 
          stored.splice(idx, 1); 
        } else { 
          stored.push(handle); 
          added = true; 
        }
        wlSave(stored);
        syncHearts();
        document.dispatchEvent(new CustomEvent('wishlist:updated'));
        toast(added
          ? '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg> Added to wishlist'
          : 'Removed from wishlist');
      });
    });

    /* Load More Logic */
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        var hiddenCards = root.querySelectorAll('.la-card.la-card--hidden');
        var batchSize = 4;
        
        for (var i = 0; i < batchSize && i < hiddenCards.length; i++) {
          hiddenCards[i].classList.remove('la-card--hidden');
          hiddenCards[i].style.display = '';
        }

        if (root.querySelectorAll('.la-card.la-card--hidden').length === 0 && loadMoreWrap) {
          loadMoreWrap.style.display = 'none';
        }
      });
    }

    syncHearts();
    window.addEventListener('storage', function (e) { if (e.key === WISHLIST_KEY) syncHearts(); });
    document.addEventListener('wishlist:updated', syncHearts);
  }

  function initAll() {
    document.querySelectorAll('.sla').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
(function () {
  var WISHLIST_KEY = 'shopify_wishlist';

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function initCollection(root) {
    var sectionId = root.dataset.sectionId;
    var drawer = document.getElementById('SmFilterDrawer-' + sectionId);
    var sortSelect = qs(root, '[data-sm-sort-select]');
    var loadMoreBtn = qs(root, '[data-sm-loadmore-btn]');

    /* Mobile Drawer Toggle */
    qsa(root, '[data-sm-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (drawer) drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    qsa(document, '[data-sm-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (drawer) drawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    });

    /* AJAX Filter & Sort Form Submissions */
    function fetchUpdatedResults(url) {
      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newRoot = doc.getElementById('SmCollection-' + sectionId);

          if (newRoot) {
            root.innerHTML = newRoot.innerHTML;
            initCollection(root);
            window.history.pushState({}, '', url);
          }
        })
        .catch(function () {});
    }

    qsa(root, '[data-sm-filter-form]').forEach(function (form) {
      form.addEventListener('change', function () {
        var formData = new FormData(form);
        var searchParams = new URLSearchParams(formData).toString();
        var url = root.dataset.collectionUrl + '?' + searchParams;
        fetchUpdatedResults(url);
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var sortValue = sortSelect.value;
        var currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('sort_by', sortValue);
        fetchUpdatedResults(currentUrl.toString());
      });
    }

    /* Wishlist Sync */
    function wlGet() {
      try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
    }
    function wlSave(arr) {
      try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr)); } catch (e) {}
    }
    function syncHearts() {
      var stored = wlGet();
      qsa(root, '[data-wishlist-toggle]').forEach(function (btn) {
        var handle = btn.dataset.handle;
        btn.classList.toggle('la-wl', stored.indexOf(handle) !== -1);
      });
    }

    qsa(root, '[data-wishlist-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = btn.dataset.handle;
        if (!handle) return;
        var stored = wlGet();
        var idx = stored.indexOf(handle);
        if (idx !== -1) { 
          stored.splice(idx, 1); 
        } else { 
          stored.push(handle); 
        }
        wlSave(stored);
        syncHearts();
        document.dispatchEvent(new CustomEvent('wishlist:updated'));
      });
    });

    syncHearts();

    /* Infinite Scroll / Load More */
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        var nextUrl = loadMoreBtn.dataset.nextUrl;
        if (!nextUrl) return;

        loadMoreBtn.classList.add('is-loading');

        fetch(nextUrl)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('[data-sm-grid]');
            var newLoadMoreWrap = doc.querySelector('[data-sm-loadmore-wrap]');
            var grid = qs(root, '[data-sm-grid]');
            var loadMoreWrap = qs(root, '[data-sm-loadmore-wrap]');

            if (newGrid && grid) {
              grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
              syncHearts();
            }

            if (newLoadMoreWrap && loadMoreWrap) {
              loadMoreWrap.innerHTML = newLoadMoreWrap.innerHTML;
              initCollection(root);
            } else if (loadMoreWrap) {
              loadMoreWrap.remove();
            }
          })
          .catch(function () {});
      });
    }
  }

  function initAll() {
    qsa(document, '.sm-coll').forEach(initCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  /* Global real-time wishlist listener across all components & tabs */
  document.addEventListener('wishlist:updated', function () {
    qsa(document, '.sm-coll').forEach(function (root) {
      var stored = JSON.parse(localStorage.getItem('shopify_wishlist')) || [];
      qsa(root, '[data-wishlist-toggle]').forEach(function (btn) {
        var handle = btn.dataset.handle;
        btn.classList.toggle('la-wl', stored.indexOf(handle) !== -1);
      });
    });
  });

  window.addEventListener('storage', function (e) {
    if (e.key === 'shopify_wishlist') {
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
(function () {
  var WISHLIST_KEY = 'shopify_wishlist';

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ---------- Wishlist ---------- */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function initWishlistButton(btn) {
    var handle = btn.dataset.productHandle;
    if (!handle) return;
    
    var label = qs(btn, '[data-wishlist-label]');
    var addText = btn.dataset.addLabel;
    var removeText = btn.dataset.removeLabel;

    function render() {
      var list = getWishlist();
      var isActive = list.indexOf(handle) !== -1;
      btn.dataset.active = isActive ? 'true' : 'false';
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      if (label) label.textContent = isActive ? removeText : addText;
    }

    if (btn.dataset.wishInit !== 'true') {
      btn.dataset.wishInit = 'true';
      btn.addEventListener('click', function () {
        var list = getWishlist();
        var idx = list.indexOf(handle);
        if (idx === -1) { 
          list.push(handle); 
        } else { 
          list.splice(idx, 1); 
        }
        setWishlist(list);
        render();
        btn.classList.add('is-pulsing');
        setTimeout(function () { btn.classList.remove('is-pulsing'); }, 400);
        document.dispatchEvent(new CustomEvent('wishlist:updated'));
      });
    }

    render();
  }

  /* Sync all wishlist buttons if updated elsewhere */
  document.addEventListener('wishlist:updated', function () {
    qsa(document, '[data-wishlist-toggle]').forEach(function (btn) {
      initWishlistButton(btn);
    });
  });
  window.addEventListener('storage', function (e) {
    if (e.key === WISHLIST_KEY) {
      qsa(document, '[data-wishlist-toggle]').forEach(function (btn) {
        initWishlistButton(btn);
      });
    }
  });

  /* ---------- Accordion ---------- */
  function initAccordion(root) {
    if (root.dataset.paccordInit === 'true') return;
    root.dataset.paccordInit = 'true';
    qsa(root, '[data-paccord-item]').forEach(function (item) {
      var trigger = qs(item, '.sm-paccord-trigger');
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    if (root.dataset.galleryInit === 'true') return;
    root.dataset.galleryInit = 'true';

    var slides = qsa(root, '[data-sm-slide]');
    var thumbs = qsa(root, '[data-sm-gallery-thumb]');
    var counterEl = qs(root, '[data-sm-gallery-current]');
    var prevBtn = qs(root, '[data-sm-gallery-prev]');
    var nextBtn = qs(root, '[data-sm-gallery-next]');
    var current = 0;

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      slides[current].classList.remove('is-active');
      thumbs[current] && thumbs[current].classList.remove('is-active');
      current = index;
      slides[current].classList.add('is-active');
      thumbs[current] && thumbs[current].classList.add('is-active');
      if (counterEl) counterEl.textContent = current + 1;
      var thumbEl = thumbs[current];
      if (thumbEl && thumbEl.scrollIntoView) {
        thumbEl.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    root.smGoTo = goTo;
    root.smGoToMediaId = function(mediaId) {
      if (!mediaId) return false;
      var strId = String(mediaId);
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.mediaId === strId) {
          goTo(i);
          return true;
        }
      }
      return false;
    };

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    /* Hover-to-zoom */
    qsa(root, '[data-sm-zoom]').forEach(function (zoomEl) {
      var img = qs(zoomEl, '[data-sm-zoom-img]');
      if (!img) return;
      var zoomSrc = img.dataset.zoomSrc;
      var isTouch = window.matchMedia('(hover: none)').matches;
      if (isTouch) return;

      var ticking = false;
      var pendingX = 50;
      var pendingY = 50;
      var loadedZoom = false;

      function applyZoom() {
        img.style.transformOrigin = pendingX + '% ' + pendingY + '%';
        ticking = false;
      }

      zoomEl.addEventListener('mouseenter', function () {
        if (zoomSrc && !loadedZoom) {
          var preload = new Image();
          preload.onload = function () { img.src = zoomSrc; };
          preload.src = zoomSrc;
          loadedZoom = true;
        }
        img.style.willChange = 'transform';
        img.style.transform = 'scale(1.85)';
      });
      zoomEl.addEventListener('mousemove', function (e) {
        var rect = zoomEl.getBoundingClientRect();
        pendingX = ((e.clientX - rect.left) / rect.width) * 100;
        pendingY = ((e.clientY - rect.top) / rect.height) * 100;
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(applyZoom);
        }
      });
      zoomEl.addEventListener('mouseleave', function () {
        img.style.transform = 'scale(1)';
        img.style.willChange = 'auto';
      });
    });

    /* Swipe support */
    var mainEl = qs(root, '[data-sm-gallery-main]');
    if (mainEl && slides.length > 1) {
      var touchStartX = 0;
      mainEl.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      mainEl.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) { dx < 0 ? goTo(current + 1) : goTo(current - 1); }
      }, { passive: true });
    }

    /* Lightbox */
    var lightbox = qs(document, '[data-sm-lightbox]');
    var expandBtn = qs(root, '[data-sm-fullscreen-open]');
    if (lightbox) {
      var lbSlides = qsa(lightbox, '[data-sm-lightbox-slide]');
      var lbCounter = qs(lightbox, '[data-sm-lightbox-current]');
      var lbPrev = qs(lightbox, '[data-sm-lightbox-prev]');
      var lbNext = qs(lightbox, '[data-sm-lightbox-next]');
      var lbClose = qs(lightbox, '[data-sm-lightbox-close]');
      var lbCurrent = 0;

      function lbGoTo(index) {
        if (!lbSlides.length) return;
        if (index < 0) index = lbSlides.length - 1;
        if (index >= lbSlides.length) index = 0;
        lbSlides[lbCurrent] && lbSlides[lbCurrent].classList.remove('is-active');
        lbCurrent = index;
        lbSlides[lbCurrent] && lbSlides[lbCurrent].classList.add('is-active');
        if (lbCounter) lbCounter.textContent = lbCurrent + 1;
      }

      function openLightbox() {
        lbGoTo(current);
        lightbox.classList.add('is-open');
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
      function closeLightbox() {
        lightbox.classList.remove('is-open');
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }

      if (expandBtn) expandBtn.addEventListener('click', openLightbox);
      qsa(root, '[data-sm-zoom]').forEach(function (z) { z.addEventListener('click', openLightbox); });
      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });
      if (lbPrev) lbPrev.addEventListener('click', function () { lbGoTo(lbCurrent - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { lbGoTo(lbCurrent + 1); });

      document.addEventListener('keydown', function (e) {
        if (!lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') lbGoTo(lbCurrent - 1);
        if (e.key === 'ArrowRight') lbGoTo(lbCurrent + 1);
      });

      var lbTouchStartX = 0;
      var lbStage = qs(lightbox, '[data-sm-lightbox-stage]');
      if (lbStage) {
        lbStage.addEventListener('touchstart', function (e) { lbTouchStartX = e.touches[0].clientX; }, { passive: true });
        lbStage.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - lbTouchStartX;
          if (Math.abs(dx) > 40) { dx < 0 ? lbGoTo(lbCurrent + 1) : lbGoTo(lbCurrent - 1); }
        }, { passive: true });
      }
    }
  }

  /* ---------- Quantity, variants, add to cart, stock ---------- */
  function formatMoney(cents) { return 'R' + (cents / 100).toFixed(2); }

  function initPdp(root) {
    if (root.dataset.pdpInit === 'true') return;
    root.dataset.pdpInit = 'true';

    var form = qs(root, '[data-sm-buyform]');
    var qtyInput = qs(root, '[data-sm-qty-input]');
    var minusBtn = qs(root, '[data-sm-qty-minus]');
    var plusBtn = qs(root, '[data-sm-qty-plus]');
    var atcBtn = qs(root, '[data-sm-atc]');
    var atcLabel = qs(root, '[data-sm-atc-label]');
    var variantSelect = qs(root, '[data-sm-variant-select]');
    var swatchButtons = qsa(root, '[data-sm-option-value]');
    var optionGroups = qsa(root, '[data-sm-option-index]');
    var priceEl = qs(root, '[data-sm-price]');
    var compareEl = qs(root, '[data-sm-price-compare]');
    var saveEl = qs(root, '[data-sm-price-save]');
    var stockEl = qs(root, '[data-sm-stock]');
    var galleryEl = qs(root, '[data-sm-gallery]');
    var stickyBar = qs(document, '[data-sm-sticky-atc]');
    var stickyBtn = stickyBar ? qs(stickyBar, '[data-sm-sticky-atc-btn]') : null;
    var stickyPrice = stickyBar ? qs(stickyBar, '[data-sm-sticky-price]') : null;

    /* Quantity controls */
    if (qtyInput) {
      if (minusBtn) minusBtn.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.value = v;
      });
      if (plusBtn) plusBtn.addEventListener('click', function () {
        var v = (parseInt(qtyInput.value, 10) || 1) + 1;
        qtyInput.value = v;
      });
      qtyInput.addEventListener('change', function () {
        var v = parseInt(qtyInput.value, 10);
        if (!v || v < 1) qtyInput.value = 1;
      });
    }

    /* Variant lookup */
    var variantMap = [];
    if (variantSelect && variantSelect.tagName === 'SELECT') {
      qsa(variantSelect, 'option').forEach(function (opt) {
        variantMap.push({
          id: opt.value,
          values: (opt.dataset.optionValues || '').split('||'),
          mediaId: opt.dataset.mediaId
        });
      });
    }

    function getSelectedValues() {
      var values = [];
      optionGroups.forEach(function (group) {
        var selected = qs(group, '.sm-variant-swatch.is-selected');
        values.push(selected ? selected.dataset.value : '');
      });
      return values;
    }

    function findMatchingVariant() {
      if (!variantMap.length) return null;
      var selected = getSelectedValues();
      for (var i = 0; i < variantMap.length; i++) {
        var match = true;
        for (var j = 0; j < selected.length; j++) {
          if (variantMap[i].values[j] !== selected[j]) { match = false; break; }
        }
        if (match) return variantMap[i];
      }
      return null;
    }

    function updateStockUI(available) {
      if (!atcBtn) return;
      atcBtn.disabled = !available;
      if (atcLabel) atcLabel.textContent = available ? atcBtn.dataset.addLabel || atcLabel.textContent : atcBtn.dataset.soldOutLabel || atcLabel.textContent;
      if (stickyBtn) stickyBtn.disabled = !available;
    }

    function fetchVariantAndUpdate(variantId) {
      if (!variantId) return;
      fetch('/products/' + root.dataset.productHandle + '.js')
        .then(function (res) { return res.json(); })
        .then(function (productData) {
          var variant = productData.variants.filter(function (v) { return String(v.id) === String(variantId); })[0];
          if (!variant) return;

          if (priceEl) priceEl.textContent = formatMoney(variant.price);
          if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            if (compareEl) { compareEl.style.display = ''; compareEl.textContent = formatMoney(variant.compare_at_price); }
            if (saveEl) {
              var save = variant.compare_at_price - variant.price;
              var pct = Math.round((save / variant.compare_at_price) * 100);
              saveEl.style.display = '';
              saveEl.textContent = 'Save ' + formatMoney(save) + ' (' + pct + '%)';
            }
          } else {
            if (compareEl) compareEl.style.display = 'none';
            if (saveEl) saveEl.style.display = 'none';
          }

          updateStockUI(variant.available);

          var mediaId = (variant.featured_media && variant.featured_media.id) || (variant.featured_image && variant.featured_image.id);
          if (mediaId && galleryEl && typeof galleryEl.smGoToMediaId === 'function') {
            galleryEl.smGoToMediaId(mediaId);
          } else if (variant.featured_image && variant.featured_image.position && galleryEl && typeof galleryEl.smGoTo === 'function') {
            galleryEl.smGoTo(variant.featured_image.position - 1);
          }

          if (stockEl) {
            var inLabel = stockEl.dataset.inLabel;
            var lowLabel = stockEl.dataset.lowLabel;
            var outLabel = stockEl.dataset.outLabel;
            var lowThreshold = parseInt(stockEl.dataset.lowThreshold, 10) || 5;
            var html = '';
            if (!variant.available) {
              html = '<span class="sm-stock__pill sm-stock__pill--out"><span class="sm-stock__dot"></span>' + outLabel + '</span>';
            } else if (variant.inventory_management === 'shopify' && typeof variant.inventory_quantity === 'number' && variant.inventory_quantity > 0 && variant.inventory_quantity <= lowThreshold) {
              html = '<span class="sm-stock__pill sm-stock__pill--low"><span class="sm-stock__dot"></span>' + lowLabel.replace('[count]', variant.inventory_quantity) + '</span>';
            } else {
              html = '<span class="sm-stock__pill sm-stock__pill--in"><span class="sm-stock__dot"></span>' + inLabel + '</span>';
            }
            stockEl.innerHTML = html;
          }

          if (variantSelect && variantSelect.tagName === 'SELECT') variantSelect.value = variantId;
          if (variantSelect && variantSelect.tagName === 'INPUT') variantSelect.value = variantId;

          history.replaceState({}, '', updateQueryParam(window.location.href, 'variant', variantId));
        })
        .catch(function () {});
    }

    function updateQueryParam(url, key, value) {
      var u = new URL(url);
      u.searchParams.set(key, value);
      return u.toString();
    }

    /* Swatch clicks */
    swatchButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-sm-option-index]');
        qsa(group, '.sm-variant-swatch').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var valueLabel = qs(group, '[data-sm-option-selected]');
        if (valueLabel) valueLabel.textContent = btn.dataset.value;

        var match = findMatchingVariant();
        if (match) {
          if (match.mediaId && galleryEl && typeof galleryEl.smGoToMediaId === 'function') {
            galleryEl.smGoToMediaId(match.mediaId);
          }
          fetchVariantAndUpdate(match.id);
        }
      });
    });

    /* Add to cart (AJAX) */
    if (form) {
      atcBtn && (atcBtn.dataset.addLabel = atcLabel ? atcLabel.textContent : 'Add to Cart');

      function showAtcError(message) {
        var existing = qs(root, '[data-sm-atc-error]');
        if (existing) existing.remove();
        var errEl = document.createElement('p');
        errEl.setAttribute('data-sm-atc-error', '');
        errEl.style.cssText = 'color:#d43040;font-size:12.5px;margin:8px 0 0;';
        errEl.textContent = message;
        var purchaseRow = qs(root, '.sm-purchase-row');
        if (purchaseRow && purchaseRow.parentNode) {
          purchaseRow.parentNode.insertBefore(errEl, purchaseRow.nextSibling);
        }
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        if (!atcBtn) return;
        if (atcBtn.disabled) return;

        var existingErr = qs(root, '[data-sm-atc-error]');
        if (existingErr) existingErr.remove();

        var formData = new FormData(form);
        var idValue = formData.get('id');

        if (!idValue) {
          showAtcError('Please select an option before adding to cart.');
          return;
        }

        atcBtn.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, data: data };
            });
          })
          .then(function (result) {
            atcBtn.classList.remove('is-loading');

            if (!result.ok || result.data.status) {
              var message = (result.data && result.data.description) || (result.data && result.data.message) || 'This item could not be added to your cart.';
              showAtcError(message);
              return;
            }

            atcBtn.classList.add('is-added');
            setTimeout(function () { atcBtn.classList.remove('is-added'); }, 1600);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(function () {
            atcBtn.classList.remove('is-loading');
            showAtcError('Something went wrong adding this to your cart. Please try again.');
          });
      });
    }

    /* Sticky ATC bar */
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (form) {
          var evt = new Event('submit', { bubbles: true, cancelable: true });
          form.dispatchEvent(evt);
        }
      });
      var toggleTarget = qs(root, '.sm-purchase-row');
      if (toggleTarget && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        }, { rootMargin: '-80px 0px 0px 0px' });
        io.observe(toggleTarget);
      }
    }
  }

  function initAll() {
    qsa(document, '[data-sm-gallery]').forEach(function (root) {
      try { initGallery(root); } catch (err) {}
    });
    qsa(document, '.sm-pdp').forEach(function (root) {
      try { initPdp(root); } catch (err) {}
    });
    qsa(document, '[data-wishlist-toggle]').forEach(function (btn) {
      try { initWishlistButton(btn); } catch (err) {}
    });
    qsa(document, '.sm-paccord-item').forEach(function (item) {
      if (item.dataset.paccordInit === 'true') return;
      item.dataset.paccordInit = 'true';
      var trigger = qs(item, '.sm-paccord-trigger');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function () {
  var WISHLIST_KEY = 'sheinme_wishlist';

  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function wlGet() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function wlSave(arr) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr)); } catch (e) {}
  }

  function initSection(root) {
    if (root.dataset.prInit === 'true') return;
    root.dataset.prInit = 'true';

    var toastEl = qs(root, '[data-pr-toast]');
    var toastTimer;
    var slider = qs(root, '[data-pr-slider]');
    var navWrap = qs(root, '[data-pr-nav-buttons]');
    var prevBtn = qs(root, '[data-pr-prev]');
    var nextBtn = qs(root, '[data-pr-next]');

    function toast(html) {
      if (!toastEl) return;
      toastEl.innerHTML = html;
      toastEl.classList.add('pr-show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('pr-show'); }, 2600);
    }

    function syncHearts() {
      var stored = wlGet();
      qsa(root, '.pr-heart').forEach(function (btn) {
        var id = parseInt(btn.dataset.pid, 10);
        btn.classList.toggle('pr-wl', stored.indexOf(id) !== -1);
      });
    }

    qsa(root, '.pr-heart').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = parseInt(btn.dataset.pid, 10);
        var stored = wlGet();
        var idx = stored.indexOf(id);
        var added = false;
        if (idx !== -1) { stored.splice(idx, 1); } else { stored.push(id); added = true; }
        wlSave(stored);
        syncHearts();
        document.dispatchEvent(new CustomEvent('wishlist:updated'));
        toast(added
          ? '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg> Added to wishlist'
          : 'Removed from wishlist');
      });
    });

    syncHearts();
    window.addEventListener('storage', function (e) { if (e.key === WISHLIST_KEY) syncHearts(); });

    initNavArrows(root);

    /* ---------- Real recommendations via Shopify's JSON API ---------- */
    var dynamicWrap = qs(root, '[data-pr-dynamic]');
    if (dynamicWrap) {
      var productId = dynamicWrap.dataset.productId;
      var limit = dynamicWrap.dataset.limit || 4;
      var intent = dynamicWrap.dataset.intent || 'related';
      var baseUrl = dynamicWrap.dataset.recommendationsUrl || '/recommendations/products.json';
      var url = baseUrl + '?product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(limit) + '&intent=' + encodeURIComponent(intent);

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = data && data.products ? data.products : [];
          if (!products.length) return; // keep the server-rendered fallback as-is
          renderRecommendedCards(root, products);
        })
        .catch(function () {
          /* Network hiccup — the server-rendered fallback grid stays visible, so nothing breaks. */
        });
    }
  }

  /* Builds cards from Shopify's recommendations JSON (prices are decimal
     strings here, e.g. "199.00" — different shape from cart.js's cents). */
  function formatMoneyDecimal(value) {
    var num = parseFloat(value);
    if (isNaN(num)) return '';
    return 'R' + num.toFixed(2);
  }

  function renderRecommendedCards(root, products) {
    var slider = qs(root, '[data-pr-slider]');
    var emptyMsg = qs(root, '[data-pr-empty]');
    if (!slider) return;

    var html = products.map(function (p) {
      var variant = (p.variants && p.variants[0]) || {};
      var price = parseFloat(p.price);
      var comparePrice = p.compare_at_price ? parseFloat(p.compare_at_price) : 0;
      var onSale = comparePrice > price;
      var pct = onSale ? Math.round(((comparePrice - price) / comparePrice) * 100) : 0;
      var save = onSale ? (comparePrice - price) : 0;
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var hoverImg = (p.images && p.images[1]) || '';
      var available = p.available !== false;
      var lowStock = available && typeof variant.inventory_quantity === 'number' && variant.inventory_management === 'shopify' && variant.inventory_quantity > 0 && variant.inventory_quantity <= 3;

      var stockHtml = !available
        ? '<span class="pr-stk pr-sout"><span class="pr-sdot"></span>Out of Stock</span>'
        : lowStock
          ? '<span class="pr-stk pr-slo"><span class="pr-sdot"></span>Only ' + variant.inventory_quantity + ' left</span>'
          : '<span class="pr-stk pr-sin"><span class="pr-sdot"></span>In Stock</span>';

      return (
        '<article class="pr-card">' +
          '<a href="' + p.url + '" class="pr-card__link" aria-label="' + escapeHtml(p.title) + '"></a>' +
          (onSale ? '<div class="pr-badges"><span class="pr-badge pr-bsale">-' + pct + '%</span></div>' : '') +
          '<button class="pr-heart" data-pid="' + p.id + '" aria-label="Add to wishlist">' +
            '<svg class="pr-heart-outline" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
            '<svg class="pr-heart-filled" viewBox="0 0 24 24" fill="currentColor"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
          '</button>' +
          '<div class="pr-img">' +
            (img
              ? '<img class="pr-img__primary" src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' +
                (hoverImg ? '<img class="pr-img__hover" src="' + hoverImg + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '')
              : '<div class="pr-iph"><svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg></div>'
            ) +
          '</div>' +
          '<div class="pr-info">' +
            (p.type ? '<div class="pr-cat">' + escapeHtml(p.type) + '</div>' : '') +
            '<div class="pr-name">' + escapeHtml(p.title) + '</div>' +
            stockHtml +
            '<div class="pr-prow"><span class="pr-price">' + formatMoneyDecimal(price) + '</span>' +
              (onSale ? '<span class="pr-was">' + formatMoneyDecimal(comparePrice) + '</span>' : '') +
            '</div>' +
            (onSale ? '<span class="pr-pill">Save ' + formatMoneyDecimal(save) + '</span>' : '') +
            '<div class="pr-btns">' +
              (available ? '<a href="' + p.url + '" class="pr-btnmain">View Details</a>' : '<span class="pr-btnmain" data-disabled>Sold Out</span>') +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }).join('');

    slider.innerHTML = html;
    if (emptyMsg) emptyMsg.hidden = true;

    /* Re-bind wishlist hearts for the freshly injected cards */
    var stored = wlGet();
    qsa(slider, '.pr-heart').forEach(function (btn) {
      var id = parseInt(btn.dataset.pid, 10);
      btn.classList.toggle('pr-wl', stored.indexOf(id) !== -1);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var list = wlGet();
        var idx = list.indexOf(id);
        if (idx !== -1) { list.splice(idx, 1); } else { list.push(id); }
        wlSave(list);
        btn.classList.toggle('pr-wl', list.indexOf(id) !== -1);
        document.dispatchEvent(new CustomEvent('wishlist:updated'));
      });
    });

    /* Refresh arrow enabled/disabled + visibility now that real cards are in */
    if (root._prUpdateNav) root._prUpdateNav();
  }

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function initNavArrows(root) {
    var slider = qs(root, '[data-pr-slider]');
    var navWrap = qs(root, '[data-pr-nav-buttons]');
    var prevBtn = qs(root, '[data-pr-prev]');
    var nextBtn = qs(root, '[data-pr-next]');
    if (!slider || !navWrap) return;

    function cardStep() {
      var card = slider.querySelector('.pr-card');
      if (!card) return 300;
      var style = window.getComputedStyle(slider);
      var gap = parseFloat(style.columnGap || style.gap || 16);
      return card.getBoundingClientRect().width + gap;
    }
    function updateNavState() {
      var maxScroll = slider.scrollWidth - slider.clientWidth - 2;
      if (maxScroll <= 0) { navWrap.hidden = true; return; }
      navWrap.hidden = false;
      if (prevBtn) prevBtn.disabled = slider.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = slider.scrollLeft >= maxScroll;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      slider.scrollBy({ left: -cardStep() * 2, behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      slider.scrollBy({ left: cardStep() * 2, behavior: 'smooth' });
    });
    slider.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateNavState);
    }, { passive: true });
    window.addEventListener('resize', updateNavState);

    root._prUpdateNav = updateNavState;
    updateNavState();
  }

  function initAll() {
    qsa(document, '.spr').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
(function () {
  var WISHLIST_KEY = 'sheinme_wishlist';

  function wlGet() { try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; } }
  function wlSave(arr) { try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(arr)); } catch (e) {} }

  function initSection(root) {
    var toastEl = root.querySelector('[data-ssr-toast]');
    var toastTimer;

    function toast(text) {
      if (!toastEl) return;
      toastEl.textContent = text;
      toastEl.classList.add('ssr-show');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('ssr-show'); }, 2200);
    }

    function syncHearts() {
      var stored = wlGet();
      root.querySelectorAll('.ssr-heart').forEach(function (btn) {
        var id = parseInt(btn.dataset.pid, 10);
        btn.classList.toggle('ssr-wl', stored.indexOf(id) !== -1);
      });
    }

    root.querySelectorAll('.ssr-heart').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var id = parseInt(btn.dataset.pid, 10);
        var stored = wlGet();
        var idx = stored.indexOf(id);
        var added = false;
        if (idx !== -1) { stored.splice(idx, 1); } else { stored.push(id); added = true; }
        wlSave(stored);
        syncHearts();
        document.dispatchEvent(new CustomEvent('wishlist:updated'));
        toast(added ? 'Added to wishlist' : 'Removed from wishlist');
      });
    });

    syncHearts();
    window.addEventListener('storage', function (e) { if (e.key === WISHLIST_KEY) syncHearts(); });
  }

  document.querySelectorAll('.ssr').forEach(initSection);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVshop(root) {
    if (root.dataset.vshopInit === 'true') return;
    root.dataset.vshopInit = 'true';

    var rail = root.querySelector('[data-vshop-rail]');
    if (!rail) return;

    var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-vshop-card]'));
    var prevBtn = root.querySelector('[data-vshop-prev]');
    var nextBtn = root.querySelector('[data-vshop-next]');
    var sectionInView = false;

    // 1. Center "Tripwire" Observer
    // Creates an invisible 2% sliver in the EXACT center of the scroll container.
    // When a video touches that center line, it becomes active.
    var centerObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target;
          var video = card.querySelector('video');

          if (entry.isIntersecting) {
            // Card hit the center
            card.classList.add('is-active');
            card.classList.remove('is-paused');

            if (video && sectionInView) {
              var playPromise = video.play();
              if (playPromise) playPromise.catch(function () {});
            }
          } else {
            // Card left the center
            card.classList.remove('is-active');
            if (video) video.pause();
          }
        });
      },
      { root: rail, rootMargin: '0px -49% 0px -49%', threshold: 0 }
    );

    cards.forEach(function (card) { centerObserver.observe(card); });

    // A leading ghost card now sits before the first real card to fill
    // the empty leading space, which means the rail's natural resting
    // scroll position (0) would center that ghost, not the real first
    // video. This needs to scroll the RAIL ONLY — using
    // card.scrollIntoView() here would scroll every scrollable
    // ancestor, including the whole page, which is exactly the kind
    // of jarring viewport jump that breaks small screens on load.
    // Calculating scrollLeft directly avoids touching the page at all.
    if (cards[0]) {
      var target = cards[0];
      var targetScrollLeft = target.offsetLeft - (rail.clientWidth / 2) + (target.offsetWidth / 2);
      rail.scrollLeft = targetScrollLeft;
    }

    // 2. Global Viewport Pause Observer
    // Pause everything if the user scrolls past the section on the page
    var viewportObserver = new IntersectionObserver(function(entries) {
      sectionInView = entries[0].isIntersecting;
      if (!sectionInView) {
        cards.forEach(function(c) {
          var v = c.querySelector('video');
          if (v) v.pause();
        });
      } else {
        var active = rail.querySelector('.vshop-card.is-active');
        if (active && !active.classList.contains('is-paused')) {
          var v = active.querySelector('video');
          if (v) v.play().catch(function(){});
        }
      }
    }, { threshold: 0.1 });
    viewportObserver.observe(root);

    // 3. User Interactions
    cards.forEach(function (card) {
      var video = card.querySelector('video');
      var muteBtn = card.querySelector('[data-vshop-mute]');
      var playBtn = card.querySelector('.vshop-play-toggle');
      var stage = card.querySelector('.vshop-video-stage');

      // Click a dimmed, inactive side-card to instantly scroll it to the center
      card.addEventListener('click', function(e) {
        if (!card.classList.contains('is-active') && !e.target.closest('.vshop-product-pill')) {
          e.preventDefault();
          var targetScrollLeft = card.offsetLeft - (rail.clientWidth / 2) + (card.offsetWidth / 2);
          rail.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
        }
      });

      // Click the active video to manually play/pause
      if (stage) {
        stage.addEventListener('click', function(e) {
          if (card.classList.contains('is-active') && video && !e.target.closest('button') && !e.target.closest('a')) {
            if (video.paused) {
              video.play();
              card.classList.remove('is-paused');
            } else {
              video.pause();
              card.classList.add('is-paused');
            }
          }
        });
      }

      // Large Play Button Toggle
      if (playBtn) {
        playBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          if (video) {
            video.play();
            card.classList.remove('is-paused');
          }
        });
      }

      // Mute Toggle
      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!video) return;
          video.muted = !video.muted;
          muteBtn.classList.toggle('is-unmuted', !video.muted);
        });
      }
    });

    // 4. Arrow Navigation
    // Uses the `cards` array (real cards only — ghosts are excluded,
    // since they were never added to it) rather than raw DOM
    // previousElementSibling/nextElementSibling, which would otherwise
    // incorrectly navigate INTO a ghost card when standing on the
    // first or last real one. Scroll position is calculated manually
    // and applied only to the rail (rail.scrollTo), not scrollIntoView,
    // which scrolls every scrollable ancestor including the page.
    function scrollRailTo(target) {
      if (!target) return;
      var targetScrollLeft = target.offsetLeft - (rail.clientWidth / 2) + (target.offsetWidth / 2);
      rail.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        var activeIdx = cards.indexOf(rail.querySelector('.vshop-card.is-active'));
        scrollRailTo(cards[Math.max(0, activeIdx - 1)]);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var activeIdx = cards.indexOf(rail.querySelector('.vshop-card.is-active'));
        scrollRailTo(cards[Math.min(cards.length - 1, activeIdx + 1)]);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.vshop').forEach(initVshop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
